export default __webpack_public_path__ + "static/media/amazonpay.83e82ecb.svg";